import Vue from 'vue'
import Router from 'vue-router'
import routes from './router.js'
import Store from '../store/index.js'

Vue.use(Router)

const router = new Router({
  // mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  Store.commit('putProductMenuStatus', false)
  if (to.name !== 'index') {
    Store.commit('getIndexSwiperRightBtn', false)
  }

  if (to.meta.title) {
    document.title = to.meta.title
  }

  next()
})

router.afterEach(to => {
  window.scrollTo(0, 0)
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js